import React from "react";
import moment from "moment";


const QuestionListItem = ({ item }) => {
    return (
        <div className="d-flex flex-row border-bottom conversation">
            <div className="pl-3 pt-2 pr-2 pb-2 conversation">
                <p className="mb-1 text-small">{moment(item.time).format("DD/MM/YYYY h:mm a")}</p>
                <div className="pr-4">
                    <p className="mb-1 text-medium">
                        {item.text}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default React.memo(QuestionListItem);